import React from 'react';

const StepHeader = ({ label, iconClass }) => {
    return (
        <div className="step--withIcon">
            <icon className={iconClass} />
            <span>{label}</span>
        </div>
    );
};

StepHeader.displayName = 'StepHeader';

export default StepHeader;
